export default __webpack_public_path__ + "static/media/calendar.769f17f9.svg";